const discountRound = (discountPercent: number) =>
  Number.isInteger(discountPercent)
    ? discountPercent
    : discountPercent.toFixed(2);

export { discountRound };
